module.exports = __webpack_public_path__ + "media/img/frontend_application/solution/venuerificpay-b63c95c3b329146fe73627520563dd79.jpg";